export default {
        "id": "320",
        "group": "0",
        "parent_id": "320",
        "animate": "1",
        "billable": "1",
        "batch_price": "1",
        "status": "1",
        "title": {
            "hu": "Merevítőrúd (stég)",
            "en": "Bar",
        },
        "hasOptions": 0,
        "hidden": 1,
        "readOnlyTitle": 1,
};
